export const isAuthorized = (roles: string[], userRoles: string[]): boolean => {
    return roles.map(role => userRoles.includes(role)).includes(true);
};

export const isAuthorizedExact = (roles: string[], userRoles: string[]): boolean => {
    return roles.slice().sort().toString() === userRoles.slice().sort().toString();
};
